/**
 * Bungee (latin subset, OFL) inlined as a data URI. Self-hosted — the page
 * loads it via @font-face in style.css for the DOM previews, and the sprite
 * rasterizer embeds THIS data URI inside the SVG string: an SVG decoded in an
 * <img> cannot fetch external resources, so the roof numbers would silently
 * fall back to sans-serif without it.
 */
import bungeeDataUri from '../assets/bungee-latin.woff2?inline';

export const BUNGEE_DATA_URI: string = bungeeDataUri;
